/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CountyView,
  FanStreetData,
  LocalityView,
  ServiceOptionView,
  ServiceView,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Nomenclator<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags nomenclator-controller
   * @name ListStreets
   * @summary A locality's whole street list, for client-side filtering
   * @request GET:/nomenclator/streets
   * @secure
   * @response `200` `(FanStreetData)[]` OK
   */
  listStreets = (
    query: {
      county: string;
      locality: string;
      search?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<FanStreetData[], any>({
      path: `/nomenclator/streets`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags nomenclator-controller
   * @name ListServiceOptions
   * @summary The extra options a service offers, for one sender
   * @request GET:/nomenclator/service-options
   * @secure
   * @response `200` `(ServiceOptionView)[]` OK
   */
  listServiceOptions = (
    query: {
      service: string;
      clientId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ServiceOptionView[], any>({
      path: `/nomenclator/service-options`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags nomenclator-controller
   * @name ListLocalities
   * @summary Localities of a county, with agency and billable extra km
   * @request GET:/nomenclator/localities
   * @secure
   * @response `200` `(LocalityView)[]` OK
   */
  listLocalities = (
    query: {
      county: string;
      search?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<LocalityView[], any>({
      path: `/nomenclator/localities`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags nomenclator-controller
   * @name ListCourierServices
   * @summary The courier's own shipping services
   * @request GET:/nomenclator/courier-services
   * @secure
   * @response `200` `(ServiceView)[]` OK
   */
  listCourierServices = (params: RequestParams = {}) =>
    this.request<ServiceView[], any>({
      path: `/nomenclator/courier-services`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags nomenclator-controller
   * @name ListCounties
   * @summary Romanian counties, spelled as the courier expects
   * @request GET:/nomenclator/counties
   * @secure
   * @response `200` `(CountyView)[]` OK
   */
  listCounties = (params: RequestParams = {}) =>
    this.request<CountyView[], any>({
      path: `/nomenclator/counties`,
      method: "GET",
      secure: true,
      ...params,
    });
}
